/**
 *
 * Asynchronously loads the component for ReferralPage
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
